export default __webpack_public_path__ + "static/media/bloodbath6.c9bb13b4.png";